import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintFLPP = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocFLPP = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PERNYATAAN PERSETUJUAN <br /> PENYALURAN KPR SEJAHTERA FLPP TA 2025
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat, Tanggal Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? "-"}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <p>Selaku Pemohon.</p>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td>:</td>
                <td>{item.sls_appl?.identity_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat, Tanggal Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(item.sls_appl?.birthat_spouse) ?? "-"}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td>:</td>
                <td>{item.sls_appl?.address_spouse ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          <p>Selaku istri/suami* pemohon.</p>
          <p>Menyatakan dengan sesungguhnya bahwa sehubungan dengan kerja sama penyaluran Subsidi Bantuan Uang Muka Perumahan (SBUM) Tahun 2025 masih dalam proses kajian internal Kementerian PUPR, maka atas fasilitas Kredit Pemilikan Rumah (KPR) Sejahtera FLPP yang Saya dan istri/suami* ajukan maka Saya dan istri/suami*:</p>
          <ol style={{ paddingLeft: "15px" }}>
            <li>Mengetahui dan menyetujui bahwa penyaluran KPR Sejahtera FLPP TA 2025 dimaksud atas pembelian rumah umum tapak pada proyek perumahan Pesona Kahuripan Cluster ……………………………………… Blok/No D2 - 14 yang dikembangkan oleh PT.Hikmah Alam Sentosa dengan fasilitas SBUM yang akan dibayarkan apabila telah dapat ditagihkan dan sesuai dengan ketentuan pada PKS SBUM TA 2025.</li>
            <li>Bersedia dilakukan pemblokiran dana sebesar Rp. 4.000.000,-/Rp. 10.000.000,-*) dan bersedia untuk dilakukan pemindahanbukuan atas dana tersebut ke Rekening Develover dengan Nomor Rekening :00130.0130.000188.0 atas nama PT.Hikmah Alam Sentosa sebagai pengganti Dana SBUM apabila fasilitas SBUM tidak dapat ditagihkan kepada Setker PUPR.</li>
          </ol>
          <p>Demikian surat pernyataan ini saya buat dengan sebenarnya tanpa paksaan dari pihak manapun dan apabila di kemudian hari pernyataan saya ini tidak benar, saya bersedia mengembalikan seluruh subsidi yang saya terima.</p>
          <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "70%",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    width: "50%",
                    textAlign: "center",
                  }}
                >
                  Menyetujui,
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    textAlign: "center",
                  }}
                >
                  ......................, tanggal ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br /> <br /> <br /> <br />
                </td>
              </tr>

              {/* Kotak Materai */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "28px 12px 8px 12px",
                    verticalAlign: "top",
                  }}
                >
                  {/* Kosong untuk tanda tangan kiri */}
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    verticalAlign: "middle",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black",
                      width: "140px",
                      height: "80px",
                      top: "-50px",
                      left: "50%",
                      padding: "10px",
                      fontSize: "12px",
                      textAlign: "center",
                      position: "absolute",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                    }}
                  >
                    Meterai
                    <br />
                    Rp. 10.000,-
                  </div>
                </td>
              </tr>

              {/* Baris tanda tangan */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  <br />
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  {item.sls_appl?.name ?? "-"}
                </td>
              </tr>

              {/* Baris Mengetahui */}
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Mengetahui,
                  <br />
                  Pengembang PT ANGGGA BUDI KUSUMA
                </td>
              </tr>

              {/* Baris tanda tangan bawah */}
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "60px 12px 20px 12px",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  Nama Lengkap, Jabatan dan Stempel
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>*)Coret salah satu yang tidak perlu</p>
      </div>
    </div>
  );
};
